/* ==========================================================================
   The Harvest Company — Guide article minimal JS.
   Two responsibilities:
     1. FAQ accordion
     2. Tag the SPECIFIC ancestor chain of <article class="hc-guide"> with
        the hc-guide-host class so reset CSS only neutralizes containers
        that wrap the article — leaves header, footer, sibling elements
        untouched.
   ========================================================================== */

(function () {
  function init() {
    // FAQ accordion
    var faqItems = document.querySelectorAll('[data-hc-faq]');
    faqItems.forEach(function (item) {
      var btn = item.querySelector('.hc-guide-faq__q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    // Walk up from .hc-guide and tag each ancestor (stopping at <body>)
    // so reset CSS can target only this article's wrappers.
    var article = document.querySelector('.hc-guide');
    if (article) {
      var node = article.parentElement;
      while (node && node !== document.body && node !== document.documentElement) {
        node.classList.add('hc-guide-host');
        node = node.parentElement;
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
